import { EventDispatcher } from '@/Event';

export abstract class AbstractController extends EventDispatcher<IControllerEvents> implements IDisposable
{
    abstract readonly name: string;

    public tick(): void
    {
    }

    public dispose(): void
    {
        this.dispatch('disconnected');
    }
}

interface IControllerEvents
{
    'button-left': [state: boolean];
    'button-right': [state: boolean];
    'button-up': [state: boolean];
    'button-down': [state: boolean];
    'button-a': [state: boolean];
    'button-b': [state: boolean];
    'button-start': [state: boolean];
    'button-select': [state: boolean];
    'save-state': [state: boolean];
    'load-state': [state: boolean];

    connected: [];
    disconnected: [];
}
